var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-section"},[_c('h2',{staticClass:"animation-item animation-top"},[_vm._v(_vm._s(_vm.header))]),_c('div',{staticClass:"default-section__inner cia-container"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }